import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PageBanner from '../components/PageBanner';
import { publicApi } from '../api/client';
import { Loader2, ArrowRight } from 'lucide-react';

const BlogList = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    publicApi.getBlog().then((d) => { setPosts(d); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  return (
    <>
      <PageBanner
        title="Egypt Travel Guide & Nile Cruise Blog"
        subtitle="Practical tips, cultural insights and expert planning advice from Egypt's most trusted Nile cruise specialists."
        image="https://images.unsplash.com/photo-1643806294235-3ee68b3bc9d2?crop=entropy&cs=srgb&fm=jpg&q=85"
        crumbs={[{ label: 'Travel Guide' }]}
      />
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          {loading ? (
            <div className="py-24 text-center"><Loader2 className="animate-spin inline text-[#304b71]" /></div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
              {posts.map((post) => (
                <Link key={post.id} to={`/blog/${post.slug}`} className="group">
                  <div className="aspect-[16/10] overflow-hidden rounded-2xl mb-5">
                    <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                  </div>
                  <div className="text-[11px] uppercase tracking-widest text-[#6a8aa4] mb-2">{(post.tags && post.tags[0]) || 'Travel Guide'}</div>
                  <h3 className="font-serif text-xl text-[#304b71] leading-snug group-hover:text-[#6a8aa4] transition-colors">{post.title}</h3>
                  <p className="mt-3 text-slate-600 text-sm leading-relaxed line-clamp-3">{post.excerpt}</p>
                  <div className="mt-4 inline-flex items-center gap-1 text-[#304b71] text-sm font-semibold group-hover:gap-2 transition-all">Read more <ArrowRight size={14} /></div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default BlogList;
